import { GetVideoQuery } from '@/graphql';
import { pathOr } from 'ramda';

export function getAdjacentVideos(video: GetVideoQuery['getVideo']): {
	prevVideo: string | null;
	nextVideo: string | null;
} {
	if (
		!video.videoCollection?.videos?.length
		//  || video?.type === 'devotion'
	) {
		return {
			prevVideo: null,
			nextVideo: null,
		};
	}

	const videoCollection = video.videoCollection.videos;
	const currentVideoIndex = videoCollection
		.map((v) => v.id)
		.indexOf(video.id);

	return {
		prevVideo:
			currentVideoIndex === 0
				? null
				: pathOr(null, [currentVideoIndex - 1, 'id'], videoCollection),
		nextVideo: pathOr(null, [currentVideoIndex + 1, 'id'], videoCollection),
	};
}
